module.exports = __webpack_public_path__ + "static/media/facebook.b56a291d.png";


//////////////////
// WEBPACK FOOTER
// ./public/facebook.png
// module id = 606
// module chunks = 0